import Factory from "../Factory";
import { FactoryInterface } from "../FactoryInterface";

import { TaskTemplate } from "../Entities/Task/TaskTemplate";
import { TaskTemplateInterface } from "../Entities/Task/TaskTemplateInterface";

class TaskTemplateFactory extends Factory implements FactoryInterface {

  public create(data: any): TaskTemplateInterface {
    return new TaskTemplate({
      id: data.id,
      name: data.name,
      details: data.details,
      executorId: data.executorId,
      daysToExecute: data.daysToExecute,
      activityTemplateId: data.activityTemplateId,
      removed: data.removed
    });
  }

  public reinitialize(data: any): TaskTemplateInterface {
    return new TaskTemplate({
      ...data
    });
  }
}

export default new TaskTemplateFactory();
